module.exports = __webpack_public_path__ + "static/media/BEDF25CC-43AB-41DD-9155-CEE28B0E1175.21921d8d.png";